// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"f13eb8de","782":"02e10a3e"}[chunkId] + ".chunk.css";
};